import { Wrench } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button, { EButtonTypes } from '@/core/components/buttons';
import '@/core/styles/maintenance.scss';

interface MaintenanceOverlayProps {
  featureName: string;
  message?: string;
}

export default function MaintenanceOverlay({ featureName, message }: MaintenanceOverlayProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const defaultMessage = t('maintenance.default_message', { feature: featureName });

  return (
    <div className="maintenance-overlay">
      <div className="maintenance-card">
        <div className="maintenance-icon">
          <Wrench size={48} weight="duotone" />
        </div>
        <h2 className="maintenance-title">{t('maintenance.title')}</h2>
        <p className="maintenance-message">
          {message || defaultMessage}
        </p>
        <Button
          type={EButtonTypes.BLUE}
          onClick={() => navigate('/')}
        >
          <span>{t('maintenance.back_to_dashboard')}</span>
        </Button>
      </div>
    </div>
  );
}